import React, { Component } from 'react'

export default class PersonalCenter extends Component {
    render() {
        return (
            <div>
                PersonalCenter
            </div>
        )
    }
}
